import { Quadkey, XyoWorldAuction } from '@xyo-network/sdk-xyoworld-js'
import BigNumber from 'bn.js'

const bigZero = new BigNumber(0)

export interface SortableAuction {
  auction: XyoWorldAuction
}

export interface SortableByBidAuction extends SortableAuction {
  bid?: BigNumber
}

export interface SortableByQuadkeyAuction extends SortableAuction {
  quadkey: Quadkey
}

export interface SortableByEndAuction extends SortableAuction {
  endTime: number
}

export const getSortByBidAuctions = (auctions: XyoWorldAuction[]): SortableByBidAuction[] => {
  return (
    auctions?.map((auction): SortableByBidAuction => {
      return {
        auction,
        bid: auction.price(),
      }
    }) ?? []
  )
}

export const getSortByQuadkeyAuctions = (auctions: XyoWorldAuction[]): SortableByQuadkeyAuction[] => {
  return auctions?.map((auction): SortableByQuadkeyAuction => {
    return {
      auction,
      quadkey: auction.quadkey,
    }
  })
}

export const getSortByEndAuctions = (auctions: XyoWorldAuction[]): SortableByEndAuction[] => {
  return auctions?.map((auction): SortableByEndAuction => {
    return {
      auction,
      endTime: auction.static?.endTime ?? 0,
    }
  })
}

export const sortAuctionsBidHighToLow = (auctions: SortableByBidAuction[]) => {
  return auctions.sort((n1, n2) => {
    const n1Bid = n1.bid ?? bigZero
    const n2Bid = n2.bid ?? bigZero
    return -n1Bid.cmp(n2Bid)
  })
}

export const sortAuctionsBidLowToHigh = (auctions: SortableByBidAuction[]) => {
  return auctions.sort((n1, n2) => {
    const n1Bid = n1.bid ?? bigZero
    const n2Bid = n2.bid ?? bigZero
    return n1Bid.cmp(n2Bid)
  })
}

export const sortAuctionsQuadkeyHighToLow = (auctions: SortableByQuadkeyAuction[]) => {
  return auctions.sort((n1, n2) => {
    return -n1.quadkey.compareTo(n2.quadkey)
  })
}

export const sortAuctionsQuadkeyLowToHigh = (auctions: SortableByQuadkeyAuction[]) => {
  return auctions.sort((n1, n2) => {
    return n1.quadkey.compareTo(n2.quadkey)
  })
}

export const sortAuctionsEndsLatestFirst = (auctions: SortableByEndAuction[]) => {
  return auctions.sort((n1, n2) => {
    if (n1.endTime > n2.endTime) {
      return -1
    }
    if (n1.endTime < n2.endTime) {
      return 1
    }
    return 0
  })
}

export const sortAuctionsEndsSoonestFirst = (auctions: SortableByEndAuction[]) => {
  return auctions.sort((n1, n2) => {
    if (n1.endTime > n2.endTime) {
      return 1
    }
    if (n1.endTime < n2.endTime) {
      return -1
    }
    return 0
  })
}
